import { useUserContext } from '@vp/ubik-context'

/**
 * Returns the current tenant identifier (e.g. 'vistaprint').
 * For service-specific tenant IDs (cart, pim, pricing, etc.), use useTenantMappings() from @vp/ubik-context.
 */
export const useTenant = (): string => {
  const tenant = useUserContext().tenant
  if (!tenant) {
    throw new Error('useTenant: tenant is not available in UserContext')
  }
  return tenant
}
